import api from "@/services/api";

export const state = {
  associationFunctions: [],
  associationFunction: {},
  cancelledChanges: [],   
};

export const mutations = {
  INIT_ASSOCIATION_FUNCTIONS(state, payload) {
    state.associationFunctions = payload;
  },

  INIT_ASSOCIATION_FUNCTION(state, payload) {
    state.associationFunction = payload;
  },

  INIT_CANCELLED_ASSOCIATION_CHANGES(state, payload) {
    state.cancelledChanges = payload;   
  },
};

export const actions = {
  getAssociationFunctions({ commit }, payload) {
    return api.getAssociationFunctions(payload).then((response) => {
      commit("INIT_ASSOCIATION_FUNCTIONS", response.data.data);

      if (!payload.retrieveAll)
        commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },

  getAssociationFunctionById({ commit }, payload) {
    return api.getAssociationFunctionById(payload).then((response) => {
      commit("INIT_ASSOCIATION_FUNCTION", response.data.data);
    });
  },

  getCancelledAssociationChanges({ commit }, payload) {
    return api
      .getCancelledAssociationChanges(payload)
      .then((response) => {
        console.log("Poništene promjene:", response.data.data);

        commit("INIT_CANCELLED_ASSOCIATION_CHANGES", response.data.data);

   
        if (!payload.retrieveAll)
          commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
      })
      .catch((error) => {
        console.error("Greška pri učitavanju poništenih promjena:", error);
      });
  },
};

export const getters = {
  getAssociationFunctions: (state) => state.associationFunctions,
  getAssociationFunction: (state) => state.associationFunction,
  getCancelledAssociationChanges: (state) => state.cancelledChanges,  
};
